export default __webpack_public_path__ + "static/olympicPark2-bfbb3ecae726a71bae70945ff09d5d91.jpeg";